import Vue from 'vue'
import LogRocket from 'logrocket'
import * as Sentry from '@sentry/browser';
import * as Integrations from '@sentry/integrations';


window.LogRocket = LogRocket;

LogRocket.init('2ejk7t/babyplant', {});

LogRocket.getSessionURL(sessionURL => {
    Sentry.configureScope(scope => {
        scope.setExtra("sessionURL", sessionURL);
    });
});

let sentryOptions = {
    dsn: process.env.MIX_SENTRY_DSN,
    integrations: [new Integrations.Vue({Vue, attachProps: true})],
    environment: process.env.MIX_SENTRY_ENVIRONMENT
}


Sentry.init(sentryOptions);
